const GoogleMap = () => {
  return (
    <section className="py-10 bg-white">
      <div className="container-custom">

        <div className="overflow-hidden rounded-3xl shadow-lg">

          <iframe
            title="AZ Construction Location"
            src="https://maps.google.com/maps?q=2,%20Gandhi%20Gram%20Colony,%20Near%20Khajrana%20Thana,%20Khajrana%20Indore&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="500"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>

        </div>

      </div>
    </section>
  );
};

export default GoogleMap;